import { render, staticRenderFns } from "./SDLC.vue?vue&type=template&id=3595ef22&scoped=true&"
import script from "./SDLC.vue?vue&type=script&lang=js&"
export * from "./SDLC.vue?vue&type=script&lang=js&"
import style0 from "./SDLC.vue?vue&type=style&index=0&id=3595ef22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595ef22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardTitle,VSelect})
